module.exports = __webpack_public_path__ + "img/11.70fa8719.png";